import 'angular/backup-and-restore/controllers';
const modules = [
    'graphdb.framework.monitoring.backupandrestore.controllers'
];

angular.module('graphdb.framework.monitoring.backupandrestore', modules);
